import React from 'react';
import { useStore } from 'routes/inventorize_meter/useStore';
import { GasDetails } from 'components/Form/meter_details/gas/GasDetails';
import { GasMeterDetailField } from 'components/Form/meter_details/gas/constants';
import { Form } from 'antd';
import { GasDeviceCategory, Nullable } from '@enmon/commons';
import { MeterDetailGas } from '@enmon/commons/lib/enmon';
import { FormItemProps } from '../../../../../components/Form/FormItem';

export const GasAdditionalFields: React.VFC<
  MeterDetailGas & { onFormItemReset: FormItemProps['onResetField']; meterId?: number }
> = ({
  diameterNominal,
  deviceCategory,
  gSize,
  measurementCategory,
  pMax,
  qMax,
  qMin,
  orientation,
  layLength,
  meterId,
  onFormItemReset,
}) => {
  const form = Form.useFormInstance();

  const formDeviceCategory =
    Form.useWatch<Nullable<GasDeviceCategory>>(['detail', 'deviceCategory'], form) ?? deviceCategory;

  const { newMeter } = useStore();

  return (
    <GasDetails
      itemsConfig={{
        [GasMeterDetailField.DeviceCategory]: {
          formItemProps: {
            getValueFromEvent: (value?: string) => value ?? null,
            initialValue: deviceCategory,
            isSemiRequired: !meterId,
            onResetField: onFormItemReset,
          },
          additionalConfig: { deviceCategory: formDeviceCategory },
        },
        [GasMeterDetailField.MeasurementCategory]: {
          formItemProps: {
            initialValue: measurementCategory,
            isSemiRequired: !meterId,
            onResetField: onFormItemReset,
          },
        },
        [GasMeterDetailField.Orientation]: {
          formItemProps: { initialValue: orientation, isSemiRequired: !meterId, onResetField: onFormItemReset },
        },
        ...(!newMeter && {
          [GasMeterDetailField.GSize]: {
            formItemProps: {
              initialValue: gSize,
              isSemiRequired: !meterId,
              onResetField: onFormItemReset,
            },
          },
        }),
        [GasMeterDetailField.DiameterNominal]: {
          formItemProps: { initialValue: diameterNominal, isSemiRequired: !meterId, onResetField: onFormItemReset },
        },
        [GasMeterDetailField.LayLength]: {
          formItemProps: { initialValue: layLength, isSemiRequired: !meterId, onResetField: onFormItemReset },
          additionalConfig: { deviceCategory },
        },
        ...(!newMeter && {
          [GasMeterDetailField.PMax]: {
            formItemProps: {
              initialValue: pMax,
              isSemiRequired: !meterId,
              onResetField: onFormItemReset,
            },
          },
          [GasMeterDetailField.QMin]: {
            formItemProps: {
              initialValue: qMin,
              isSemiRequired: !meterId,
              onResetField: onFormItemReset,
            },
          },
          [GasMeterDetailField.QMax]: {
            formItemProps: {
              initialValue: qMax,
              isSemiRequired: !meterId,
              onResetField: onFormItemReset,
            },
          },
        }),
      }}
    />
  );
};
